module.exports = __webpack_public_path__ + "Flag-372.4d260cb15bc1a4d1b35d8f1c8d3933c1.svg";